// Badge / Pill — a small status or count chip. Semantic tones are separate
// from the brand accent (see tokens), so "danger" never borrows brand color.
// Pair a status tone with a word — never rely on color alone.
//
//   <Badge tone="good">Active</Badge>
//   <Badge tone="warn" dot>Pending</Badge>
//   <Badge tone="brand">{count}</Badge>
//   <Badge tone="neutral" size="lg">Draft</Badge>

import { HTMLAttributes, ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'brand' | 'good' | 'warn' | 'danger' | 'info' | 'outline';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  /** Render a leading status dot. */
  dot?: boolean;
  size?: 'md' | 'lg';
  children: ReactNode;
}

export default function Badge({ tone = 'neutral', dot, size = 'md', className, children, ...rest }: BadgeProps) {
  const cls = [
    'ui-badge',
    `ui-badge--${tone}`,
    size === 'lg' ? 'ui-badge--lg' : '',
    className ?? '',
  ].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {dot && <span className="ui-badge__dot" aria-hidden />}
      {children}
    </span>
  );
}
